import { styled } from '@mui/material';

export const SubscriptionCard = styled('div')(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(5),
  display: 'flex',
  flex: '1 1 auto',
  borderRadius: theme.shape.borderRadius * 1.5,
  gap: theme.spacing(6),
  backgroundColor: theme.designTokens.white,
  position: 'relative',
  maxWidth: '330px',
}));

export const PriceTitle = styled('span')(() => ({
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '19.2px',
  letterSpacing: '-0.02em',
  color: '#64748B',
  textAlign: 'center',
}));

export const Price = styled('span')(() => ({
  fontWeight: 600,
  fontSize: '36px',
  lineHeight: '50.4px',
  letterSpacing: '-0.02em',
  color: '#2A35D8',
  textAlign: 'center',
}));

export const PricePeriod = styled('span')(() => ({
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '19.2px',
  letterSpacing: '-0.02em',
  color: '#64748B',
  textAlign: 'center',
}));

export const Discount = styled('div')(({ theme }) => ({
  color: theme.palette.common.white,
  backgroundColor: theme.palette.success.main,
  position: 'absolute',
  right: theme.spacing(-3),
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2),
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
  fontSize: '14px',
  lineHeight: '16px',
  fontWeight: 600,
}));
